module.exports = __webpack_public_path__ + "images/emoji/crown.d8875b08da7f5e61dc18.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/crown.png
// module id = IPru
// module chunks = 14